import { makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { Fragment, useContext } from "react";
import { Route } from "react-router-dom";
import AppContext from "../../../data/AppContext";
import * as Constants from "../../../data/StringConstants";
/**
 * @todo - discuss moving `PageSectionHeader` into /src/components since its ubiquitous
 */
import PageSectionHeader from "../../../layouts/Main/components/Page/PageSectionHeader";
import { getComponentForMatchedRoute, isAllItemsRoute, isFolderDetailsRoute, parseFolderIdFromCurrentHash } from "../../../utils/routingHelpers";
import AllItemsContainer from "../AllItems/AllItemsContainer";
import CreateFolderDialogButton from "../CreateFolderButtonContainer/CreateFolderDialogButton";
import Sidebar from "../FoldersSideBar/FoldersSidebar";
import ItemsContainer from "../Items/ItemsContainer";


const useStyles = makeStyles((theme) => ({
	container: {
		display: "flex",
		flex: "1 1 auto",
		overflow: "hidden"
	},
	content: {
		padding: theme.spacing(2, 6),
		flex: "1 1 auto",
		overflowY:'hidden'
	}
}));

/**
 * @description 
 * @exports
 * @param {object} props
 * @param {object} props.location - routing location object
 * @see {LA.Web::Scripts::React::utils::routingHelpers.js} for further routing related implementation
 * @param {object} props.permissions - contains boolean user role key:value pairs
 * @see {LibraryAwareWeb::Shared::Layouts::_Main.cshtml} for props.permissions implementation
 * @returns
 */
export default function FoldersPage(props) {
	const classes = useStyles();
	const { location: { hash } } = props;
	const appContext = useContext(AppContext);

	return (
		<Fragment>
			<div className={classes.container}>
				<Sidebar {...props} />
				<div className={classes.content}>
					<Route
						render={props => {
							// Determine if this a Folders sub-page or a Folders details page (ex: /folders/123)
							if (isFolderDetailsRoute(hash)) {
								const folderId = parseFolderIdFromCurrentHash(hash);

								return (
									<ItemsContainer
										folderId={folderId}
										user={appContext.user}
									/>
								);
							} else if (isAllItemsRoute(hash)) {
								return (
									<AllItemsContainer
										description={Constants.HEADER_DESCRIPTION_ALL_ITEMS}
										name={Constants.HEADER_TEXT_ALL_ITEMS}
										user={appContext.user}
										{...props}
									/>
								);
							} else {
								/**
								 * @description This is a matched sub-page (ex: /folders/my-folders) and it"s `name`
								 * and `description`
								 */
								const MatchedContext = getComponentForMatchedRoute(hash);
								const MatchedComponent = MatchedContext.component;
								return (
									<Fragment>
										<PageSectionHeader
											name={MatchedContext.name}
											description={MatchedContext.description}
											primaryActions={() => appContext.user.isEditor
												&& <CreateFolderDialogButton history={props.history} matchedComponentName={MatchedContext.name} />}
										/>
										<MatchedComponent matchedComponentName={MatchedContext.name} {...props} />
									</Fragment>
								);
							}
						}}
					/>
				</div>
			</div>
		</Fragment>
	);
}

FoldersPage.propTypes = {
	location: PropTypes.shape({
		hash: PropTypes.string
	}).isRequired,
};
